import { Model } from 'modules/core/lib/mobx-rest'

export interface ICategory {
  id: string
  label: string
  mcc: string[] | null
  payroll_sync?: boolean
}

class Category extends Model<ICategory> {
  static urlRoot() {
    return '/expenses/categories'
  }
}

export default Category
